import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates if a given control's value is a valid email address.
 *
 * This validator checks the provided control's value against a regular expression
 * to determine if it adheres to the standard rules of email format.
 *
 * Addresses longer than 64 characters are rejected so they match the stored column.
 *
 * @return {ValidatorFn} A validation function that returns null if the control's value is a valid email,
 * or an error object containing `invalidEmail: true` if the value is invalid.
 */
export function emailValidator(): ValidatorFn {
	const localChar = "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-";
	const emailRegex = new RegExp(
		'^(?!.*\\.\\.)(?!.*\\.$)[' + localChar + '][.' + localChar + ']{0,63}@[a-zA-Z\\d.-]+\\.[a-zA-Z]{2,}$'
	);
	return (control: AbstractControl): ValidationErrors | null => {
		const value: unknown = control.value;
		if (typeof value !== 'string' || value.length > 64 || !emailRegex.test(value)) {
			return { invalidEmail: true };
		}
		return null;
	};
}
